export default "__VITE_ASSET__f35fd4ce__"